import css from 'styled-jsx/css';

export default css`.login-container {
    min-height: 278px;
    background: #FFFFFF;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    .top-switch-icon {
        position: absolute;
        top: 0;
        right: 0;
        width: 56px;
        height: 56px;
        text-align: right;
        img {
            width: 100%;
            height: 100%;
            cursor: pointer;
        }
    }
}`